import { Component, Inject, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ErrorDialogConfig } from './error-dialog.types';

@Component({
    selector: 'error-dialog',
    templateUrl: './error-dialog.component.html',
    styles: [
        /* language=SCSS */
        `
            .error-dialog-panel {
                @screen md {
                    @apply w-128;
                }

                .mat-mdc-dialog-container {

                    .mat-mdc-dialog-surface {
                        padding: 0 !important;
                    }
                }
            }
        `
    ],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ErrorDialogComponent {
    /**
     * Constructor
     */
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: ErrorDialogConfig,
        public matDialogRef: MatDialogRef<ErrorDialogComponent>
    ) { }

}
